import React from "react";
import { DeviceActivityEmptyStateTemplate } from "themes/administration/analytics/components";

function DeviceActivityEmptyState(props) {
    return <DeviceActivityEmptyStateTemplate {...props} />;
}

export default DeviceActivityEmptyState;
